import React, { ReactNode } from 'react';
import styled from 'styled-components';

const isDev = process.env.NODE_ENV === 'development';

type Props = {
  children: ReactNode | ReactNode[];
};

// const Wrapper = styled.div<{
//   isDev: boolean;
// }>`
//   display: flex;
//   flex-direction: column;

//   @media (min-width: 768px) {
//     height: ${({ isDev }) => {
//       return isDev ? `100vh` : 'calc(100vh - 129px)';
//     }};
//   }
//   height: ${({ isDev }) => {
//     return isDev ? `100vh` : 'calc(100vh - 116px)';
//   }};
//   max-height: 100vh;
// `;

const Wrapper = styled.div<{
  isDev: boolean;
}>`
  display: flex;
  flex-direction: column;
  height: 705px;
  max-height: 100%;

  @media (min-width: 768px) {
    height: 705px;
  }

  @media (min-width: 1441px) {
    height: 950px;
    min-height: 850px;
    max-height: 100%;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    height: 100%;
    max-height: 100%;
  }
  @media (min-width: 1068px) and (max-width: 1235px) {
    height: 890px!important;
  }
  @media (min-width: 1024px) and (max-width: 1440px) {
    height: 950px!important;
  }
  @media (min-width: 1441px) and (max-width: 1960px) {
    height: 950px;
    max-height: 100%;
  }

  @media (max-width: 767px) {
    height: 100%;
    max-height: 100%;
  }
`;

export const AppWrapper = ({ children }: Props) => {
  return <Wrapper isDev={isDev}>{children}</Wrapper>;
};
